import * as THREE from 'three';
import { windowOutline } from '../configurator/windowShapes';

export const HOUSE_SCENES = ['exterior', 'interior'];

function glassTexture(scene) {
  const canvas = document.createElement('canvas'); canvas.width = 64; canvas.height = 512;
  const ctx = canvas.getContext('2d'), gradient = ctx.createLinearGradient(0, 0, 0, 512);
  if (scene === 'interior') { gradient.addColorStop(0, '#cfe3f6'); gradient.addColorStop(.42, '#eef4f3'); gradient.addColorStop(.6, '#d9e3cf'); gradient.addColorStop(1, '#9fb48c'); }
  else { gradient.addColorStop(0, '#6d7f8c'); gradient.addColorStop(.35, '#3b474f'); gradient.addColorStop(1, '#1d2226'); }
  ctx.fillStyle = gradient; ctx.fillRect(0, 0, 64, 512);
  const texture = new THREE.CanvasTexture(canvas); texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
}

// House scenes: the AI paints the house, so the glass must read as glazing on
// its own — dim reflective interior from outside, bright daylight from inside.
export function addGlassBackdrop(model, design, fixed, scene) {
  const texture = glassTexture(scene), material = new THREE.MeshBasicMaterial({ map: texture, toneMapped: false });
  for (const run of model.runs) {
    const outline = windowOutline(fixed ? design.window_shape || 'rectangle' : 'rectangle', run.width - .01, run.height - .01);
    const geometry = new THREE.ShapeGeometry(new THREE.Shape(outline.map(([x, y]) => new THREE.Vector2(x, y + .005))));
    const position = geometry.attributes.position, uv = geometry.attributes.uv;
    for (let i = 0; i < position.count; i++) uv.setXY(i, .5, position.getY(i) / run.height);
    const mesh = new THREE.Mesh(geometry, material); mesh.name = 'concept-glass-backdrop'; mesh.position.z = -run.depth / 2 - .02;
    run.group.add(mesh);
  }
  return () => { material.dispose(); texture.dispose(); };
}

// Where the exact product sits inside the 1024² layer the AI house is painted behind.
export function houseFraming(fixed, span) {
  const widthShare = fixed ? .5 : .62, heightShare = fixed ? .42 : .64;
  const frame = Math.max(span.x / widthShare, span.y / heightShare);
  const centerFromTop = fixed ? .47 : .84 - span.y / frame / 2;
  return { frame, centerFromTop };
}
